// Import packages
import {connect} from "react-redux";
import React, {useEffect, useState} from "react";
import ExcelJS from "exceljs";
import {saveAs} from "file-saver";
import dayjs from "dayjs";
import "../../../assets/styles/dataDisplay/generateTimelineExcel.scss"

//import components
import {MaterialIcon} from "../../../components/utils/Icon";

//import utils
import {WEEKDAY_TYPES, WORKOUT_TYPE_CONST} from "../../../constants/constsTypes";
import {GetAllGroupWorkoutTimelines} from "../../../redux/actions";
import {mapStateToProps} from "../../../redux/mapStateToProps";
import {localTime, makeUTCTime} from "../../../utils/dateHelper";
import {trainerIds} from "../../../constants/constIds";
import moment from "moment/moment";
import {LinkButton} from "../../../components/buttons/buttons";


function DownloadGroupWorkoutExcel(props) {
    const {timeline} = props;
    const [workoutTimeLine, setWorkoutTimeLine] = useState(null);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        timeline && processTimeLine()
    }, [timeline]);

    async function processTimeLine() {
        const workoutTimeLine = {}
        Object.keys(WEEKDAY_TYPES).forEach(key => {
            workoutTimeLine[key] = timeline?.filter(item => item.weekday === key && !item?.workout?.is_hidden)
        })
        console.log('workoutTimeLine', workoutTimeLine);
        setWorkoutTimeLine(workoutTimeLine)
    }

    async function downloadExcel() {
        setLoading(true)
        try {
            const excelName = 'Շաբաթվա մարզումների ցանկ -' + dayjs().format('DD-MM-YYYY');

            const workbook = new ExcelJS.Workbook();
            const sheet = workbook.addWorksheet("Sheet1");
            const startOfWeek = dayjs().day(1);
            const columns = [];

            const dateRow = sheet.getRow(1);
            const weekRow = sheet.getRow(2);
            const infoRow = sheet.getRow(3);

            for (let i = 0; i < 7; i++) {
                const startIndex = (i * 5) + 1;
                const weekday = Object.values(WEEKDAY_TYPES)[i];

                columns.push(
                    {key: String(startIndex), width: 8},
                    {key: String(startIndex + 1), width: 30},
                    {key: String(startIndex + 2), width: 15},
                    {key: String(startIndex + 3), width: 10},
                )
                if (i !== 6) {
                    columns.push({key: String(startIndex + 4), width: 2},)
                }

                // Date Row
                dateRow.getCell(startIndex + 1).value = startOfWeek.add(i, 'day').format('DD.MM.YYYY');

                // Week Row
                sheet.mergeCells(2, startIndex, 2, startIndex + 3)
                const weekCell = weekRow.getCell(startIndex);
                weekCell.value = weekday.name;
                weekCell.alignment = {vertical: 'middle', horizontal: 'center'};
                weekCell.font = {
                    color: {argb: 'FFFFFFFF'},
                };
                weekCell.fill = {
                    type: 'pattern',
                    pattern: 'solid',
                    fgColor: {argb: 'FF000000'}
                };

                infoRow.getCell(startIndex).value = 'Ժամ';
                infoRow.getCell(startIndex + 1).value = 'Մարզում';
                infoRow.getCell(startIndex + 2).value = 'Մարզիչ';
                infoRow.getCell(startIndex + 3).value = 'Քանակ';
            }
            sheet.columns = columns;


            //Add timeline data
            for (let i = 0; i < 7; i++) {
                const cellStartIndex = (i * 5) + 1;
                const rowStartIndex = 4;
                const weekday = Object.values(WEEKDAY_TYPES)[i];
                const timeLineDataList = workoutTimeLine?.[weekday.key];
                if (timeLineDataList.length) {
                    for (let j = 0; j < timeLineDataList.length; j++) {
                        const timeLineData = timeLineDataList[j];
                        const row = sheet.getRow(rowStartIndex + j);

                        const trainersTitle = timeLineData?.trainers?.length ?
                            `${timeLineData?.trainers?.map(t => {
                                const [firstName, lastName] = t?.name?.split(' ');
                                let name = `${firstName}${trainerIds?.includes(t.id) ? ` ${lastName?.slice(0, 3)}` : ''}`
                                return name
                            }).join(', ')}`
                            : '';

                        row.getCell(cellStartIndex).value = localTime(timeLineData?.start_time);
                        row.getCell(cellStartIndex + 1).value = timeLineData?.workout?.title || "";
                        row.getCell(cellStartIndex + 2).value = trainersTitle;
                        row.getCell(cellStartIndex + 3).value = ' ';

                        const weekAddition = weekday.index;
                        const endTimeWeekAddition = weekAddition + (makeUTCTime(timeLineData.end_time).hour() === 0 ? 1 : 0)

                        const cancellationDate = timeLineData?.workout?.workout_cancellations?.find(c => {
                            return makeUTCTime(timeLineData.start_time).day(weekAddition).valueOf()
                                < moment(c.date).valueOf() && moment(c.date).valueOf() <
                                makeUTCTime(timeLineData.end_time).day(endTimeWeekAddition).valueOf()
                        })
                        if (cancellationDate) {
                            row.getCell(cellStartIndex).fill = {
                                type: 'pattern',
                                pattern: 'solid',
                                fgColor: {argb: 'FFffbdbd'}
                            };
                        }
                        const isAquaType = timeLineData?.workout?.workout_types?.includes(WORKOUT_TYPE_CONST.AQUA);
                        const isKidsType = timeLineData?.workout?.workout_types?.includes(WORKOUT_TYPE_CONST.CHILDREN);

                        if (isAquaType || isKidsType) {
                            row.getCell(cellStartIndex + 1).fill = {
                                type: 'pattern',
                                pattern: 'solid',
                                fgColor: {argb: isAquaType ? 'FFb3e9ff' : 'FFffc3b0'}
                            };
                        }
                    }
                }
            }

            sheet.eachRow((row, rowNumber) => {
                if (rowNumber > 2) {
                    row.eachCell((cell, colNumber) => {
                        cell.alignment = {vertical: "middle", horizontal: "center"};
                        cell.border = {
                            top: {style: 'thin', color: {argb: 'FF000000'}},
                            left: {style: 'thin', color: {argb: 'FF000000'}},
                            bottom: {style: 'thin', color: {argb: 'FF000000'}},
                            right: {style: 'thin', color: {argb: 'FF000000'}}
                        };
                        if (rowNumber === 3) {
                            cell.fill = {
                                type: 'pattern',
                                pattern: 'solid',
                                fgColor: {argb: 'FFE0E0E0'}
                            };
                        }
                    });
                }
            });

            const buffer = await workbook.xlsx.writeBuffer();
            saveAs(new Blob([buffer]), `${excelName}.xlsx`);

        } catch {
            setLoading(false)
        }
        setLoading(false)
    }


    return <div className={'generate-timeline-excel-wrapper'}>
        <LinkButton title={<><MaterialIcon icon="download"/> Excel</>}
                    disabled={!workoutTimeLine}
                    cb={downloadExcel}
                    loadingWithTitle
                    loading={loading}/>
    </div>
}

const mapDispatchToProps = {
    GetAllGroupWorkoutTimelines,
};

export default connect(mapStateToProps, mapDispatchToProps)(DownloadGroupWorkoutExcel);
